import DispositiviDataTable from '../../components/DispositiviDataTable/DispositiviDataTable';

const Dispositivi = () => {
    return (
        <>
            <DispositiviDataTable></DispositiviDataTable>
        </>
    );
}

export default Dispositivi;